import { render, staticRenderFns } from "./BaseDropdownButton.vue?vue&type=template&id=fc4631e6&scoped=true"
import script from "./BaseDropdownButton.vue?vue&type=script&lang=js"
export * from "./BaseDropdownButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownButton.vue?vue&type=style&index=0&id=fc4631e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4631e6",
  null
  
)

export default component.exports